export default "__VITE_ASSET__829febc8__"